import { Button } from "./ui/button";
import { Home, Bot, Users, Phone, BookOpen, ShoppingCart, Sparkles } from "lucide-react";
import { NavLink } from "./NavLink";
import TrustRibbon from "./TrustRibbon";

const Navigation = () => {
  const navLinks = [
    { to: "/", icon: Home, label: "Home" },
    { to: "/robots", icon: Bot, label: "Robots" },
    { to: "/ai-automation", icon: Sparkles, label: "AI Automation" },
    { to: "/case-studies", icon: Users, label: "Case Studies" },
    { to: "/accessories", icon: ShoppingCart, label: "Accessories" },
    { to: "/blog", icon: BookOpen, label: "Blog" },
    { to: "/about", icon: Users, label: "About" },
    { to: "tel:3369624539", icon: Phone, label: "Contact" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <TrustRibbon />

      <nav
        aria-label="Primary"
        className="glass-strong border-b border-neon backdrop-blur-xl bg-background/95"
        style={{ boxShadow: "0 8px 32px hsl(var(--primary) / 0.18)" }}
      >
        <div className="max-w-7xl mx-auto px-3 py-2 md:px-4 md:py-3">
          {/* Top row: brand + CTA */}
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0">
              <p className="text-[10px] sm:text-xs md:text-sm font-semibold text-muted-foreground leading-tight">
                NEIL AI GLOBAL SOLUTIONS LLC
              </p>
            </div>

            <Button asChild size="sm" variant="secondary" className="font-bold glow-gold shrink-0 text-xs md:text-sm px-3 py-1.5 h-8 md:h-9">
              <a
                href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Demo
              </a>
            </Button>
          </div>

          {/* Bottom row: icon nav */}
          <div className="mt-2 flex items-center gap-1.5 md:gap-2 flex-wrap justify-start">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className="flex items-center justify-center gap-1.5 h-8 w-8 md:h-10 md:w-10 lg:w-auto lg:px-3 lg:py-2 rounded-full glass-effect hover:glass-strong transition-all duration-300 text-xs md:text-sm font-medium"
                  activeClassName="border-neon glow-cyan"
                >
                  <Icon className="h-3.5 w-3.5 md:h-4 md:w-4" />
                  <span className="hidden lg:inline">{link.label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navigation;
